import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=16622ef5"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/myapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16622ef5')) {
      api.createRecord('16622ef5', component.options)
    } else {
      api.reload('16622ef5', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=16622ef5", function () {
      api.rerender('16622ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/pages/Home.vue"
export default component.exports